export default "__VITE_ASSET__DMvTWUV$__"